import { SlideOverContentWrapper } from '@/components/slideOvers_v2/SlideOverContentWrapper';
import { SlideOverFooter } from '@/components/slideOvers_v2/SlideOverFooter';
import { SlideOverWrapper } from '@/components/slideOvers_v2/SlideOverWrapper';
import { showToast } from '@/features/toasts/toastsSlice';
import { Input } from '@/lib';
import { ISlideOverContentProps } from '@/models/slideOver';
import { ToastType } from '@/models/toast';
import { useAppDispatch } from '@/reducers';
import { useChangeUserInfoMutation } from '@/services/endpoints/users';
import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserDetailInfo } from './types';
import { UserDetailHeader } from './UserDetailHeader';

interface IUserDetailSlideOverProps extends ISlideOverContentProps {
  disabled?: boolean;
  showSave?: boolean;
  user: UserDetailInfo;
}

export const UserDetailSlideOver: FunctionComponent<IUserDetailSlideOverProps> = ({ user, disabled = true, showSave = false, closeSlideOver }) => {
  const { t } = useTranslation('users');
  const dispatch = useAppDispatch();

  const [editedUser, setEditedUser] = useState(user);
  const [updateUserInfo] = useChangeUserInfoMutation();

  const handleSave = async () => {
    try {
      await updateUserInfo({
        userId: editedUser.id,
        firstName: editedUser.firstName,
        lastName: editedUser.lastName,
      }).unwrap();

      dispatch(
        showToast({
          type: ToastType.SUCCESS,
          title: t('info.update_success'),
        })
      );
      closeSlideOver();
    } catch (e) {
      dispatch(
        showToast({
          type: ToastType.ERROR,
          title: t('info.update_error'),
        })
      );
    }
  };

  // TODO: Reset Password?
  return (
    <SlideOverWrapper>
      <div className='flex min-h-0 flex-1 flex-col py-6'>
        <UserDetailHeader user={user} />
        <SlideOverContentWrapper className='mt-10' isScrollable={false}>
          <div>
            <h3 className='mb-2 text-lg font-semibold text-brand-600'>{t('personalInfo')}</h3>
            <div className='space-y-4'>
              <div>
                <label className='mb-1 block text-sm font-medium text-gray-700'>{t('name')}</label>
                <Input value={editedUser.firstName || ''} disabled={!showSave} onChange={(e) => setEditedUser({ ...editedUser, firstName: e.target.value })} />
              </div>

              <div>
                <label className='mb-1 block text-sm font-medium text-gray-700'>{t('surname')}</label>
                <Input value={editedUser.lastName || ''} disabled={!showSave} onChange={(e) => setEditedUser({ ...editedUser, lastName: e.target.value })} />
              </div>

              <div>
                <label className='mb-1 block text-sm font-medium text-gray-700'>{t('email')}</label>
                <Input type='email' value={editedUser.email} disabled={disabled} />
              </div>
            </div>
          </div>
        </SlideOverContentWrapper>
      </div>

      <SlideOverFooter
        closeSlideOver={closeSlideOver}
        confirmLabel={t('slideover.save')}
        onConfirmClicked={handleSave}
        showCancelButton={true}
        cancelLabel={t('slideover.close')}
      />
    </SlideOverWrapper>
  );
};
